import { render, staticRenderFns } from "./AvocadoTreeList.vue?vue&type=template&id=388b243e&scoped=true"
import script from "./AvocadoTreeList.vue?vue&type=script&lang=js"
export * from "./AvocadoTreeList.vue?vue&type=script&lang=js"
import style0 from "./AvocadoTreeList.vue?vue&type=style&index=0&id=388b243e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b243e",
  null
  
)

export default component.exports